import { sha256 } from 'js-sha256';

import { getEncryptValue } from '@/utils';
import { API2_HOST } from '@/utils/constants';

import fetchData from './http';
import { IBaseResponse, IResult } from './types/common';

export function userFindPasswordValidation(params: any) {
  const url = `${API2_HOST}/user/find-password/validation`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

export function userFindPassword(params: any) {
  const url = `${API2_HOST}/user/find/password`;

  params.password = sha256(params.password);
  params.samepassword = sha256(params.samepassword);
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 风控策略新接口
export function newUserFindPasswordValidation(params: any) {
  const url = `${API2_HOST}/user/public/find-password/intercept`;
  return new Promise((resolve, reject) => {
    fetchData
      .post<IBaseResponse<IResult>>(url, {
        body: JSON.stringify(params),
      })
      .then((res) => {
        resolve(res.result);
      })
      .catch((error) => {
        reject(error.response ? error.response.data : error);
      });
  });
}

// 风控策略下发新接口
export function newUserFindPassword(params: any) {
  const url = `${API2_HOST}/user/public/find-password/verify`;

  params.password = sha256(params.password);
  params.samepassword = sha256(params.samepassword);
  return new Promise((resolve, reject) => {
    getEncryptValue(params, false)
      .then((res: any) => {
        fetchData
          .post<IBaseResponse<IResult>>(url, {
            body: JSON.stringify(res),
          })
          .then((res) => {
            resolve(res.result);
          })
          .catch((error) => {
            reject(error.response ? error.response.data : error);
          });
      })
      .catch((error) => {
        reject(error);
      });
  });
}
